import React, {
  useEffect,
  useState,
  useMemo,
  useCallback,
  useRef,
} from "react";
import { useNavigate, useParams } from "react-router-dom";
import moment from "moment";
import { useLocation } from "react-router-dom";
import { selectClasses } from "@mui/material";
import { AxiosInstance } from "../../../../axios";
import Loader from "../../Loader";
import TestPerformance from "./TestPerformance";
// import styles from "../StudentTestWorkflow/Test.module.css";
import styles from "./TestPerformance.module.css";

// Debounce function to prevent rapid successive API calls
const debounce = (func, delay) => {
  let timer;
  return function (...args) {
    clearTimeout(timer);
    timer = setTimeout(() => func.apply(this, args), delay);
  };
};

function TestPerformanceTablist() {
  const { active_tab, batchIds, batch_type } = useParams();
  const navigate = useNavigate();
  const [currentPage, setCurrentPage] = useState(1);
  const [isLoading, setIsLoading] = useState(false);
  const [activeTab, setActiveTab] = useState(Number(active_tab) || 1);
  const [sortKey, setSortKey] = useState("sno");
  const [sortOrder, setSortOrder] = useState("asc");
  const [tPer, setTPer] = useState([]);
  const [tPerstatus, setTPerstatus] = useState(null);
  const [batchId, setBatchId] = useState(batchIds || null);
  const [batchType, setBatchType] = useState(batch_type || null);
  const [tabClicked, setTabClicked] = useState(false);
  const [reportData, setReportData] = useState([]);
  const [eeventName, setEeventName] = useState([]);
  const [eeventNames, setEeventNames] = useState([]);
  const [selectedEvent, setSelectedEvent] = useState([]);
  const [updateChipData, setUpdateChipData] = useState([]);
  const [selectedSubject, setSelectedSubject] = useState([]);
  const [subject, setSubject] = useState([]);
  const [selectedStatus, setselectedStatus] = useState([]);
  const [status, setStatus] = useState([]);
  const [selectedToppics, setSelectedToppics] = useState([]);
  const [testTopics, settestTopics] = useState([]);
  const [appOn, setAppOn] = useState([]);
  const [csvData, setCsvData] = useState([]);
  const [combineTest, setCombineTest] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [dateFilter, setDateFilter] = useState({
    FDate: "",
    TDate: "",
  });
  const [appData, setAppData] = useState({
    FDate: "",
    TDate: "",
    Days: "",
    name: "",
  });
  const location = useLocation();
  const userJSON = sessionStorage.getItem("userDetails");
  const userid = userJSON ? JSON.parse(userJSON)?.user_id : null;
  const isMounted = useRef(true);
  const abortControllerRef = useRef(new AbortController());
  const isInitialMount = useRef(true);

  // Clean up on unmount
  useEffect(() => {
    return () => {
      isMounted.current = false;
      abortControllerRef.current.abort();
    };
  }, []);

  const handleView = (event_id, batch_id, statuses, event_type, type_batch) => {
    const typeValue =
      type_batch === "single_exam" ? 0 : type_batch === "combined_exam" ? 1 : 0;

    navigate(
      `/ViewTestDetail/${batch_id}/${event_id}/${statuses}/${event_type}/${type_batch}/1`,
      {
        state: {
          STATUS: selectedStatus,
          EVENTNAMES: selectedEvent,
          SUBJECT: selectedSubject,
          TESTTOPICS: selectedToppics,
          TQMARKS: initialfields,
          APPON: appOn,
          ACTIVETAB: activeTab,
          BATCHIDS: batchId,
          BATCHTYPE: typeValue,
          SEARCHTERM: searchTerm,
          DATEFILTER: dateFilter,
          APPDATA: appData,
        },
      }
    );
  };

  useEffect(() => {
    if (location.state && isInitialMount.current) {
      const {
        filStatus,
        fillEventNames,
        fillSubject,
        fillTestTopics,
        fillTQMarks,
        fillAppOn,
        fillActiveTab,
        fillBatchId,
        fillBatchType,
        fillSearch,
        DATEFILTER,
        APPDATA,
      } = location.state;

      // Restore all filter states
      setselectedStatus(filStatus || []);
      setSelectedEvent(fillEventNames || []);
      setSelectedSubject(fillSubject || []);
      setSelectedToppics(fillTestTopics || []);
      setSearchTerm(fillSearch || "");

      // Restore date filter states
      if (DATEFILTER) {
        setDateFilter(DATEFILTER);
      }

      // Restore marks filter
      if (fillTQMarks) {
        setInitialfields({
          fromDate: fillTQMarks.fromDate || "",
          toDate: fillTQMarks.toDate || "",
        });
      }

      if (fillAppOn.length > 0) {
        setAppData({
          FDate: fillAppOn[0].fdate,
          TDate: fillAppOn[0].edate,
          Days: fillAppOn[0].Days,
          name: fillAppOn[0].name,
        });

        setAppOn(fillAppOn || []);
      }

      // Generate updateChipData array
      const chipData = [];

      // Status chips
      if (filStatus?.length > 0) {
        filStatus.forEach((item) => {
          chipData.push({ type: item.type, id: item.id, name: item.name });
        });
      }

      // Event name chips
      if (fillEventNames?.length > 0) {
        fillEventNames.forEach((item) => {
          chipData.push({ type: item.type, id: item.id, name: item.name });
        });
      }

      // Subject chips
      if (fillSubject?.length > 0) {
        fillSubject.forEach((item) => {
          chipData.push({ type: item.type, id: item.id, name: item.name });
        });
      }

      // Test topic chips
      if (fillTestTopics?.length > 0) {
        fillTestTopics.forEach((item) => {
          chipData.push({ type: item.type, id: item.id, name: item.name });
        });
      }

      // Applied on chips (date range)
      if (fillAppOn?.length > 0) {
        fillAppOn.forEach((item) => {
          chipData.push({
            type: item.type,
            id: item.id,
            name: item.name,
            fdate: item.fdate,
            edate: item.edate,
          });
        });
      }

      // Total marks chips
      if (fillTQMarks && (fillTQMarks.fromDate || fillTQMarks.toDate)) {
        chipData.push({
          type: "tot_marks",
          name: `${fillTQMarks.fromDate || ""} - ${fillTQMarks.toDate || ""}`,
          value: "tot_marks",
        });
      }

      // Search term chip
      if (fillSearch) {
        chipData.push({
          type: "search",
          name: `${fillSearch}`,
          value: fillSearch,
        });
      }

      // Date filter chips (if present in DATEFILTER)
      if (DATEFILTER && (DATEFILTER.FDate || DATEFILTER.TDate)) {
        chipData.push({
          type: "dateFilter",
          name: `${DATEFILTER.FDate || ""} - ${DATEFILTER.TDate || ""}`,
          value: "dateFilter",
        });
      }

      setUpdateChipData(chipData);

      // Restore active tab
      if (fillActiveTab !== undefined) {
        setActiveTab(fillActiveTab);
      }

      // Restore batch selection
      if (fillBatchId) {
        const matchingBatch = tPer.find(
          (batch) => batch.batch_id === fillBatchId
        );
        if (matchingBatch) {
          setBatchId(matchingBatch.batch_id);
          setBatchType(matchingBatch.batch_type);
        } else {
          setBatchId(fillBatchId);
          if (fillBatchType && fillBatchType !== "undefined") {
            setBatchType(fillBatchType);
          }
        }
      }

      isInitialMount.current = false;
    }
  }, [location.state, tPer]);
  const [isOpen, setIsopen] = useState({
    eventName: false,
    subject: false,
    tot_marks: false,
    appliedOn: false,
    status: false,
  });

  // Initial data fetch
  useEffect(() => {
    if (!userid) return;

    const fetchInitialData = async () => {
      if (isLoading) return;

      // setIsLoading(true);
      abortControllerRef.current = new AbortController();

      try {
        const batchResponse = await AxiosInstance.post(
          "api/batch/list/byUser",
          { user_id: userid },
          { signal: abortControllerRef.current.signal }
        );

        if (
          batchResponse.data?.status === true &&
          Array.isArray(batchResponse.data?.data)
        ) {
          const batches = batchResponse.data.data;
          setTPer(batches);
          setTPerstatus(batchResponse.data?.view_performer);

          const initialBatch =
            (!batchIds || batchIds === "null") && batches.length > 0
              ? batches[0]
              : null;

          if (initialBatch) {
            setBatchId(initialBatch.batch_id);
            setBatchType(initialBatch.batch_type);
            setActiveTab(1);
          }
        }
      } catch (error) {
        if (error.name !== "AbortError") {
          console.error("Error fetching data:", error);
        }
      } finally {
        if (isMounted.current) {
          setIsLoading(false);
        }
      }
    };

    fetchInitialData();
  }, [userid]);

  // Main API call effect
  useEffect(() => {
    if (!batchId) return;

    // const timer = setTimeout(() => {
    debouncedFetchTestReport(batchId);
    // }, 200);

    // return () => clearTimeout(timer);
  }, [batchId, updateChipData]);

  // Debounced fetch function
  const debouncedFetchTestReport = useCallback(
    debounce(async (batch_id) => {
      if (!userid || !batch_id || !isMounted.current) return;

      setIsLoading(true);
      abortControllerRef.current = new AbortController();

      try {
        const dateChip = updateChipData.find(
          (chip) => chip?.type === "dayRange" || chip?.type === "dateRange"
        );
        const startDate = dateChip?.fdate || "";
        const endDate = dateChip?.edate || "";

        const payload = {
          batch_id: batch_id,
          type: batchType,
          user_id: userid,
          event: selectedEvent.map((e) => e.id),
          start_date: startDate,
          end_date: endDate,
          status:
            selectedStatus.length > 0
              ? selectedStatus.map((obj) => Number(obj.id))
              : "",
          subject: selectedSubject.map((s) => s.id).join(","),
          test_topic: selectedToppics.map((t) => t.id).join(","),
          search: searchTerm.trim(),
          start_no_of_que: "",
          end_no_of_que: "",
          start_tot_marks: initialfields.fromDate,
          end_tot_marks: initialfields.toDate,
          start_marks_obtained: "",
          end_marks_obtained: "",
        };

        const response = await AxiosInstance.post(
          "api/test/report/list/byUser",
          payload,
          { signal: abortControllerRef.current.signal }
        );

        if (response.data?.status === true) {
          setIsLoading(false);
          const el = response.data.data;

          const fiata = processData(el);

          const csvFormattedData = fiata.map((item, index) => ({
            serialNumber: index + 1,
            description: item.event_name || item.exam_name || "",
            url: "", // Add actual URL if available in your data
            category_name: item.subject?.subject || "", // Assuming subject might be an object
            displayDate:
              item.start_date && item.end_date
                ? `${moment(item.start_date).format("DD/MM/YYYY")} - ${moment(
                  item.end_date
                ).format("DD/MM/YYYY")}`
                : "",
            status: item.status === 0 ? "Completed" : "Absent",
          }));

          setCsvData(csvFormattedData);

          if (Array.isArray(fiata)) {
            const singleExams = [];
            let combinedExams = [];

            fiata.forEach((el) => {
              if (el.type === "single_exam") {
                singleExams.push(el);
              } else if (el.type === "combined_exam") {
                combinedExams.push(el);
              }
            });

            setReportData([...singleExams]);
            setCombineTest([...combinedExams]);
          }

          const eeventSet = fiata.flatMap((event) =>
            event.event_name
              ? [{ event_name: event.event_name, event_pk: event.event_pk }]
              : []
          );

          const subjectSet = fiata.flatMap((event) => event.subject || []);
          const uniqueSubjects = Array.from(
            new Map(
              subjectSet
                .filter((subj) => subj && subj.subject)
                .map((subj) => [subj.subject.toLowerCase(), subj])
            ).values()
          );

          const testtopicSet = fiata.flatMap((event) => event.test_topic || []);
          const uniqueTestTopics = Array.from(
            new Map(
              testtopicSet
                .filter((topic) => topic && topic.test_topic)
                .map((topic) => [topic.test_topic.toLowerCase(), topic])
            ).values()
          );

          setEeventName(eeventSet);
          setEeventNames(eeventSet);
          setSubject(uniqueSubjects);
          settestTopics(uniqueTestTopics);
        } else {
          setCombineTest([]);
          setReportData([]);
        }
      } catch (error) {
        setIsLoading(false);
        if (error.name !== "AbortError") {
          setIsLoading(false);
          console.error("Failed to fetch test report:", error);
          setCombineTest([]);
          setReportData([]);
        }
      } finally {
        if (isMounted.current) {
          setIsLoading(false);
        }
      }
    }, 300),
    [
      selectedEvent,
      selectedSubject,
      selectedStatus,
      selectedToppics,
      updateChipData,
      userid,
      searchTerm,
    ]
  );

  const handleSearch = () => {
    if (!batchId) return;
    // Clear previous results while loading
    setReportData([]);
    setCombineTest([]);
    setIsLoading(true);

    // Update chip data with search term if it exists
    if (searchTerm.trim() !== "") {
      const searchChip = {
        type: "search",
        name: `${searchTerm}`,
        value: searchTerm,
      };

      // Remove any existing search chip and add the new one
      setUpdateChipData((prev) => [
        ...prev.filter((chip) => chip.type !== "search"),
        searchChip,
      ]);
      setSearchTerm("");
    } else {
      // Remove search chip if search term is empty
      setUpdateChipData((prev) =>
        prev.filter((chip) => chip.type !== "search")
      );
    }
    debouncedFetchTestReport(batchId);
  };

  // Process data function remains the same
  const processData = (data) => {
    const structuredData = [];

    if (data.single_exam && data.single_exam.length) {
      data.single_exam.forEach((exam) => {
        structuredData.push({
          ...exam,
          type: "single_exam",
        });
      });
    }

    if (data.combined_exam && data.combined_exam.length) {
      data.combined_exam.forEach((combined) => {
        const combinedExamGroup = {
          exam_name: combined.exam_name,
          tot_marks: combined.tot_marks,
          marks_obtained: combined.marks_obtained,
          cut_off: combined.cut_off,
          event_rank: combined.event_rank,
          over_all_event_rank: combined.over_all_event_rank,
          exam_data: [],
          type: "combined_exam",
        };

        combined.exam_data.forEach((exam) => {
          combinedExamGroup.exam_data.push({
            ...exam,
            type: "single_exam",
          });
        });

        structuredData.push(combinedExamGroup);
      });
    }

    return structuredData;
  };

  const debouncedSearch = useCallback(
    debounce(() => {
      if (batchId) {
        debouncedFetchTestReport(batchId);
      }
    }, 500),
    [batchId]
  );
  const handleApplyFilter = () => {
    let tempArr = [];
    if (initialfields.fromDate || initialfields.toDate) {
      tempArr.push({
        name: `${initialfields.fromDate || 0} - ${initialfields.toDate || 0}`,
        value: `tot_marks`,
        type: "tot_marks",
      });
    }
    setUpdateChipData([
      ...selectedEvent,
      ...selectedSubject,
      ...appOn,
      ...selectedStatus,
      ...selectedToppics,
      ...tempArr,
    ]);

    // Close all filter boxes
    setIsopen({
      eventName: false,
      subject: false,
      tot_marks: false,
      appliedOn: false,
      status: false,
    });
  };
  // Tab click handler
  const handleTabClick = (index, batch_id, batch_type) => {
    if (isLoading) return;

    if (activeTab !== index) {
      setSelectedEvent([]);
      setSelectedSubject([]);
      setselectedStatus([]);
      setSelectedToppics([]);
      setAppOn([]);
      setSearchTerm("");
      setAppData({
        FDate: "",
        TDate: "",
        Days: "",
        name: "",
      });
      setUpdateChipData([]);
    }

    setTabClicked(true);
    setActiveTab(index);
    setBatchId(batch_id);
    setBatchType(batch_type);
  };

  // Date change handlers (unchanged from original)
  const handleChangeDate = (date, name) => {
    const dateFilter = moment(date).format("YYYY-MM-DD");

    if (name === "FDate" || name === "TDate") {
      setAppData((prevState) => {
        const updated = {
          ...prevState,
          [name]: dateFilter,
          Days: "",
        };

        const from = name === "FDate" ? dateFilter : updated.FDate;
        const to = name === "TDate" ? dateFilter : updated.TDate;

        if (from && to) {
          const dateRange = `${from} - ${to}`;
          setAppOn([
            {
              name: dateRange,
              fdate: moment(from).format("YYYY-MM-DD"),
              edate: moment(to).format("YYYY-MM-DD"),
              type: "dateRange",
              Days: "",
            },
          ]);
        }

        return updated;
      });
    }
  };

  //   const handleFilterSearch = (event, names) => {
  //   console.log(names,"namesnames");

  //   if (names == "eventName") {
  //     const searchInput = event.target.value;
  //     if (searchInput !== "") {
  //       const matchingObjects = eeventName.filter(
  //         (item) =>
  //           item.event_name &&
  //           item.event_name.toLowerCase().includes(searchInput.toLowerCase())
  //       )

  //       setEeventNames(matchingObjects);
  //     } else {
  //       setEeventNames(eeventName);
  //     }
  //   }
  // };
  const handleFilterSearch = (event, names) => {
    const searchInput = event.target.value.toLowerCase();

    if (names === "eventName") {
      if (searchInput !== "") {
        const matchingObjects = eeventName.filter(
          (item) =>
            item.event_name &&
            item.event_name.toLowerCase().includes(searchInput)
        );
        setEeventNames(matchingObjects);
      } else {
        setEeventNames(eeventName);
      }
    } else if (names === "subject") {
      if (searchInput !== "") {
        const matchingSubjects = subject.filter(
          (item) =>
            item.subject && item.subject.toLowerCase().includes(searchInput)
        );
        setSubject(matchingSubjects);
      } else {
        // Reset to original subject list when search is cleared
        // You might want to maintain the original list in a separate state if needed
        const uniqueSubjects = Array.from(
          new Map(
            reportData
              .flatMap((event) => event.subject || [])
              .filter((subj) => subj && subj.subject)
              .map((subj) => [subj.subject.toLowerCase(), subj])
          ).values()
        );
        setSubject(uniqueSubjects);
      }
    }
  };

  const handleAppliedOn = (e) => {
    const { name, value, checked } = e.target;

    if (name === "FDate" || name === "TDate") {
      setAppData((prevState) => {
        const updated = {
          ...prevState,
          [name]: value,
          Days: "",
        };

        const from = name === "FDate" ? value : updated.FDate;
        const to = name === "TDate" ? value : updated.TDate;

        if (from && to) {
          const dateRange = `${from} - ${to}`;
          setAppOn([
            {
              name: dateRange,
              fdate: moment(from).format("YYYY-MM-DD"),
              edate: moment(to).format("YYYY-MM-DD"),
              type: "dateRange",
              Days: "",
            },
          ]);
        } else {
          setAppOn([
            {
              name: "",
              fdate: "",
              edate: "",
              type: "dateRange",
              Days: "",
            },
          ]);
        }

        return updated;
      });
    } else if (name === "Days") {
      if (checked) {
        setAppData({
          FDate: "",
          TDate: "",
          Days: value,
        });

        const today = new Date();
        let fdate = "";
        let edate = "";
        let label = "";

        if (value === "Today") {
          fdate = edate = moment(today).format("YYYY-MM-DD");
          label = "Today";
        } else if (value === "Yesterday") {
          const yesterday = new Date(today);
          yesterday.setDate(yesterday.getDate() - 1);
          fdate = edate = moment(yesterday).format("YYYY-MM-DD");
          label = "Yesterday";
        } else if (value === "Tweek") {
          const start = moment(today).startOf("week").toDate();
          const end = moment(today).endOf("week").toDate();
          fdate = moment(start).format("YYYY-MM-DD");
          edate = moment(end).format("YYYY-MM-DD");
          label = "This week";
        } else if (value === "Lweek") {
          const start = moment(today)
            .subtract(1, "week")
            .startOf("week")
            .toDate();
          const end = moment(today).subtract(1, "week").endOf("week").toDate();
          fdate = moment(start).format("YYYY-MM-DD");
          edate = moment(end).format("YYYY-MM-DD");
          label = "Last week";
        } else if (value === "Tmonth") {
          const start = new Date(today.getFullYear(), today.getMonth(), 1);
          const end = new Date(today.getFullYear(), today.getMonth() + 1, 0);
          fdate = moment(start).format("YYYY-MM-DD");
          edate = moment(end).format("YYYY-MM-DD");
          label = "This month";
        } else if (value === "Lmonth") {
          const start = new Date(today.getFullYear(), today.getMonth() - 1, 1);
          const end = new Date(today.getFullYear(), today.getMonth(), 0);
          fdate = moment(start).format("YYYY-MM-DD");
          edate = moment(end).format("YYYY-MM-DD");
          label = "Last month";
        }

        setAppOn([
          {
            name: label,
            fdate,
            edate,
            type: "dayRange",
            Days: value,
          },
        ]);
      }
    }
  };

  // Checkbox handler (unchanged)
  const handleCheckboxChange = (event, names) => {
    const { value, checked, name } = event.target;

    if (names === "status") {
      if (checked) {
        if (!selectedStatus.some((item) => item.id === value)) {
          setselectedStatus([
            ...selectedStatus,
            { id: value, name: name, type: "status" },
          ]);
        }
      } else {
        setselectedStatus(selectedStatus.filter((item) => item.id !== value));
      }
    } else if (names === "eventName") {
      if (checked) {
        if (!selectedEvent.some((item) => item.id === value)) {
          setSelectedEvent([
            ...selectedEvent,
            { id: value, name: name, type: "eventName" },
          ]);
        }
      } else {
        setSelectedEvent(selectedEvent.filter((item) => item.id !== value));
      }
    } else if (names === "subject") {
      if (checked) {
        setSelectedSubject([
          ...selectedSubject,
          { id: value, name: name, type: "subject" },
        ]);
      } else {
        setSelectedSubject(selectedSubject.filter((item) => item.id !== value));
      }
    } else if (names === "test_topic") {
      if (checked) {
        settestTopics([
          ...testTopics,
          { id: value, name: name, type: "test_topic" },
        ]);
      } else {
        settestTopics(testTopics.filter((item) => item.id !== value));
      }
    }
  };

  // Sort handler
  const handleSort = useCallback(
    (key) => {
      const order = sortKey === key && sortOrder === "asc" ? "desc" : "asc";
      setSortKey(key);
      setSortOrder(order);
    },
    [sortKey, sortOrder]
  );

  // Sorted data
  // const sortedReportData = useMemo(() => {
  //   return [...reportData].sort((a, b) => {
  //     let valA = a[sortKey] ?? "";
  //     let valB = b[sortKey] ?? "";
  //     const isNumber = !isNaN(valA) && !isNaN(valB);

  //     if (isNumber) return sortOrder === "asc" ? valA - valB : valB - valA;

  //     return sortOrder === "asc"
  //       ? valA.toString().localeCompare(valB.toString())
  //       : valB.toString().localeCompare(valA.toString());
  //   });
  // }, [reportData, sortKey, sortOrder]);

  const sortedReportData = useMemo(() => {
    return [...reportData].sort((a, b) => {
      let valA, valB;

      // Handle subject sorting
      if (sortKey === "subject") {
        valA = a.subject?.map((s) => s.subject).join(", ") || "";
        valB = b.subject?.map((s) => s.subject).join(", ") || "";
      }
      // Handle test topic sorting
      else if (sortKey === "test_topic") {
        valA = a.test_topic?.map((t) => t.test_topic).join(", ") || "";
        valB = b.test_topic?.map((t) => t.test_topic).join(", ") || "";
      }
      // Default case for other fields
      else {
        valA = a[sortKey] ?? "";
        valB = b[sortKey] ?? "";
      }

      const isNumber = !isNaN(valA) && !isNaN(valB);

      if (isNumber) return sortOrder === "asc" ? valA - valB : valB - valA;

      return sortOrder === "asc"
        ? valA.toString().localeCompare(valB.toString())
        : valB.toString().localeCompare(valA.toString());
    });
  }, [reportData, sortKey, sortOrder]);

  // Filter chip deletion
  const handleDelete = (chipToDelete, index) => () => {
    if (chipToDelete.type === "eventName") {
      setSelectedEvent(
        selectedEvent.filter((event) => event.id !== chipToDelete.id)
      );
    }
    if (chipToDelete.type === "tot_marks") {
      setInitialfields({ fromDate: "", toDate: "" });
    } else if (chipToDelete.type === "subject") {
      setSelectedSubject(
        selectedSubject.filter((subject) => subject.id !== chipToDelete.id)
      );
    } else if (chipToDelete.type === "test_topic") {
      setSelectedToppics(
        selectedToppics.filter((topic) => topic.id !== chipToDelete.id)
      );
    } else if (chipToDelete.type === "status") {
      setselectedStatus(
        selectedStatus.filter((status) => status.id !== chipToDelete.id)
      );
    } else if (
      chipToDelete.type === "dayRange" ||
      chipToDelete.type === "dateRange"
    ) {
      setAppOn([]);
      setAppData({
        FDate: "",
        TDate: "",
        Days: "",
        name: "",
      });
    } else if (chipToDelete.type === "search") {
      setSearchTerm("");
    }

    setUpdateChipData(updateChipData.filter((chip, i) => i !== index));
  };

  const [initialfields, setInitialfields] = useState({
    fromDate: "",
    toDate: "",
  });

  const handleClear = (filterType) => {
    if (filterType === "tot_marks") {
      setInitialfields({});
      setIsopen((prev) => ({ ...prev, tot_marks: false }));
      setUpdateChipData((prev) =>
        prev.filter((chip) => chip.type !== "tot_marks")
      );
    }
    if (filterType === "all") {
      setInitialfields({});
      setSelectedEvent([]);
      setSelectedSubject([]);
      setSelectedToppics([]);
      setselectedStatus([]);
      setAppOn([]);
      setAppData({
        FDate: "",
        TDate: "",
        Days: "",
        name: "",
      });
      setSearchTerm("");
      setUpdateChipData([]);
      setIsopen({
        eventName: false,
        subject: false,
        tot_marks: false,
        appliedOn: false,
        status: false,
      });
    } else if (filterType === "search") {
      setSearchTerm("");
      setUpdateChipData((prev) =>
        prev.filter((chip) => chip.type !== "search")
      );
    } else {
      switch (filterType) {
        case "eventName":
          setSelectedEvent([]);
          setUpdateChipData((prev) =>
            prev.filter((chip) => chip.type !== "eventName")
          );
          setIsopen((prev) => ({ ...prev, eventName: false }));
          break;
        case "subject":
          setSelectedSubject([]);
          setUpdateChipData((prev) =>
            prev.filter((chip) => chip.type !== "subject")
          );
          setIsopen((prev) => ({ ...prev, subject: false }));
          break;
        case "test_topic":
          setSelectedToppics([]);
          setUpdateChipData((prev) =>
            prev.filter((chip) => chip.type !== "test_topic")
          );
          setIsopen((prev) => ({ ...prev, test_topic: false }));
          break;
        case "status":
          setselectedStatus([]);
          setUpdateChipData((prev) =>
            prev.filter((chip) => chip.type !== "status")
          );
          setIsopen((prev) => ({ ...prev, status: false }));
          break;
        case "startDate":
          setAppOn([]);
          setAppData({
            FDate: "",
            TDate: "",
            Days: "",
            name: "",
          });
          setUpdateChipData((prev) =>
            prev.filter(
              (chip) => chip.type !== "dayRange" && chip.type !== "dateRange"
            )
          );

          setIsopen((prev) => ({ ...prev, appliedOn: false }));
          break;
        default:
          break;
      }
    }
  };

  // Date filter change
  const handleDateFilterChange = (newFilter) => {
    setDateFilter(newFilter);
  };
  const handleMarksChange = (event) => {
    let { name, value } = event.target;
    setInitialfields((prevFields) => ({
      ...prevFields,
      [name]: value,
    }));
  };

  return isLoading ? (
    <div
      className="loaderApi"
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        position: "fixed",
        top: 0,
        left: 0,
        width: "100%",
        height: "100%",
        backgroundColor: "white",
        zIndex: 999,
      }}
    >
      <Loader />
    </div>
  ) : (
    <div className={`BathHeader`}>
      <div className="col-md-6 col-12">
        <h2 className="TitleHeader">Test Performance</h2>
      </div>

      <div className="row mt-3">
        <div className="col-md-12 ">
          <ul
            className={`nav cm_nav-fill mb-3 ${styles.listViewTabs}`}
            id="cm_listViewTabs"
            role="tablist"
          >
            {tPer.length > 0 ? (
              tPer.map((el, index) => (
                <li className="nav-item" role="presentation" key={el.batch_id}>
                  <a
                    className={
                      activeTab === index + 1 ? "nav-link active" : "nav-link"
                    }
                    href="#"
                    role="tab"
                    aria-selected={activeTab === index + 1}
                    onClick={(e) => {
                      e.preventDefault();
                      handleTabClick(index + 1, el.batch_id, el.batch_type);
                    }}
                  >
                    {el.batch_name}
                  </a>
                </li>
              ))
            ) : (
              <li className="nav-item" role="presentation">
                <a
                  className="nav-link active"
                  href="javascript:void(0)"
                  role="tab"
                >
                  NO BATCH FOUND
                </a>
              </li>
            )}
          </ul>
        </div>
      </div>

      <div>
        <TestPerformance
          reportData1={combineTest}
          reportData={sortedReportData}
          onSort={handleSort}
          eeventName={eeventNames}
          selectedEvent={selectedEvent}
          setSelectedEvent={setSelectedEvent}
          handleCheckboxChange={handleCheckboxChange}
          handleApplyFilter={handleApplyFilter}
          subject={subject}
          selectedSubject={selectedSubject}
          setSelectedSubject={setSelectedSubject}
          testTopics={testTopics}
          selectedToppics={selectedToppics}
          status={status}
          setselectedStatus={setselectedStatus}
          settestTopics={settestTopics}
          dateFilter={dateFilter}
          handleDateFilterChange={handleDateFilterChange}
          isOpen={isOpen}
          handleChange={handleMarksChange}
          initialfields={initialfields}
          setIsopen={setIsopen}
          handleDelete={handleDelete}
          appData={appData}
          setAppData={setAppData}
          updateChipData={updateChipData}
          handleFilterSearch={handleFilterSearch}
          appOn={appOn}
          setAppOn={setAppOn}
          batchId={batchId}
          batchType={batchType}
          activeTab={activeTab}
          handleAppliedOn={handleAppliedOn}
          handleClear={handleClear}
          handleChangeDate={handleChangeDate}
          selectedStatus={selectedStatus}
          IsLoading={isLoading}
          setIsLoading={setIsLoading}
          handleView={handleView}
          // debouncedSearch={debouncedSearch}
          searchTerm={searchTerm}
          setSearchTerm={setSearchTerm}
          handleSearch={handleSearch}
        />
      </div>
    </div>
  );
}

export default TestPerformanceTablist;
